<template>
  <div class="right">
    <rightTop @data="getCreditDataFn"></rightTop>

    <div class="rightCenter">
      <div class="centerTit">控股参股</div>
      <div style="width:80%;position: relative;">
        <div
          @click="downloadFn(0)"
          style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:21px;margin-left:20px;"
        >
          <img
            src="@/assets/img/Excel.png"
            alt
            style="display: inline-block;height: 18px;width:18px;float:left;"
          />
          <span
            style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;"
          >下载数据到Excel</span>
        </div>
        <div style="width:296px;float:right;position: relative;">
          <el-select
            @change="SelectTimeFn1"
            v-model="searchData1.value"
            size="small"
            placeholder="请选择"
          >
            <el-option v-for="item in searchData1.select" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <div
            style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 61px;vertical-align: middle;line-height: 61px;color: #fff;"
          >截止日期：</div>
          <!-- <div @click="SelectTimeFn1" style="position: absolute;top: 0;left:0;width:100%;height: 100%;cursor: pointer;"></div> -->
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <el-table border size="mini" :data="tableData" :header-cell-style="cellStyle">
          <el-table-column width="60" :show-overflow-tooltip="true" label="序号">
            <template slot-scope="scope">{{scope.$index+1+(currentPage-1)*limit}}</template>
          </el-table-column>
          <el-table-column prop="corporateName" label="公司名称"></el-table-column>
          <el-table-column prop="participatoryHoldingRelationship" label="参控股关系"></el-table-column>
          <el-table-column prop="controlledRatio" label="参控比例(%)"></el-table-column>
          <el-table-column prop="businessNature" label="业务性质"></el-table-column>
        </el-table>
      </div>
      <div style="width:100%;margin-top:40px;">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          :current-page="currentPage"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
export default {
  data() {
    return {
      //选择数据
      searchData1: {
        select: [], //下拉框选项数据
        value: ""
      },
      tableData: [],
      companyList: [],
      paramsData: {}, //URL参数集合
      offset: 0, //page
      limit: 10,
      total: 0,
      currentPage: 1
    };
  },
  components: {
    rightTop
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data) {
      console.log(data, "mytest");
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      // this.paramsData.stockCode = "300034";
      // this.paramsData.enterpriseCode = '96cd49d4-7e23-11ea-b3e3-005056b8154d';
      this.fetchTimes();
      // setTimeout(()=>{this.fetchTable()},500)//获取表格数据
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      return "color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;";
    },
    // 分页函数
    handleCurrentChange(val) {
      //当前页
      this.currentPage = val;
      this.offset = (val - 1) * this.limit;
      this.fetchTable();
    },
    //下载函数
    downloadFn(incomeType) {
      let _this = this;
      this.download(
        window.baseUrl +
          "/capitalOperation/downHoldingSharesData?stockCode=" +
          this.paramsData.stockCode +
          "&enterpriseCode=" +
          this.paramsData.enterpriseCode
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val) {
      console.log(val, "val");
      this.offset = 0;
      this.fetchTable(); //按产品
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    //获取所有时间的选项
    fetchTimes() {
      let _this = this;
      api
        .controllersTimeOne(
          this.paramsData.stockCode,
          this.paramsData.enterpriseCode
        )
        .then(res => {
          let data = res.data;
          _this.searchData1.select = data;
          _this.searchData1.value = data[0];
          this.fetchTable();
        });
    },
    fetchTable() {
      let _this = this;
      let params = {
        stockCode: this.paramsData.stockCode,
        enterpriseCode: this.paramsData.enterpriseCode,
        closeDate: this.searchData1.value,
        offset: this.offset,
        limit: this.limit
      };
      api.controllersOne(params).then(res => {
        let data = res.data.rows;
        // _this.total = Math.ceil(Number(res.data.total)/Number(_this.limit));
        _this.total = res.data.total;
        // console.log(res,'data');
        _this.tableData = data;
      });
    }
  },
  mounted() {}
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #dfdfdf;
}
.mailTable {
  font-size: 14px;
  color: #4b4b4b;
  width: 100%;
  font-family: Microsoft YaHei;
}
.mailTable tr td {
  border: 1px solid #dfdfdf;
  width: 80%;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  padding: 0 10px;
}
.mailTable .column {
  background-color: #f7f7f7;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/view/capital/controllers.vue